import { collect } from '../collect';
import { setConfig } from '../config';
import { LISTENERS, setCurrent } from '../phase';
import { isNodeEnvironment } from '../utils';
export const LooselyLazy = {
  init: config => {
    setConfig(config);
    LISTENERS.length = 0;
    setCurrent(0);
    if (!isNodeEnvironment()) {
      collect();
    }
  }
};